
export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {
  // in colorPicker.dialog
  'COLOR_PICKER': 'Color Picker',
  'SUCCESSFULLY_LOGGED_IN': 'Successfully logged in',
  // in content.component
  "ONLY_SHOW_DATA": "I'm only show data",
  "READY_FOR_CHECK": "Ready for check in and out",
  "WORK_TIME": "Work Time",
  "BREAK_TIME": "Break Time",
  "TO_DO": "To do",
  // in reconnect.dialog
  "SUCCESSFULLY_DISCNNECTED": "Successfully disconnected",
  "RECONNECT": "Reconnect",
  // in settings.dialog
  'SETTINGS': 'Settings',
  "SHOW_WORKERS": "Show Workers",
  "WORKER_FILTER": "Worker filter",
  "WORKER_FILTER_DEFAULT": "Default",
  "WORKER_FILTER_ALL": "Show all",
  "WORKER_FILTER_CHECKEDIN": "Show all checked in",
  "WORKER_FILTER_DISABLED_HINT": "You can enable this option in the interface within projectfacts",
  "WORKER_IMAGES": "Worker images",
  "WORKER_COLUMN_COUNT": "Max column count",
  "WORKER_SHOW_ABSENT": "Absent workers",
  "FULL_DATA_RESET": "Full data reset",
  "CLEAR_ALL_DATA": "Clear all local saved data. Include connection with Projectfacts and all settings.",
  "VERSION": "Version",
  "SHOW_WORKERBACKGROUND": "Show backgroundimage at check in/out",
  "LITTLE_MESSAGE_BLOCK": "Little timeblock",
  // in login.component
  "WRONG_DATA_INPUT": "Wrong data input. Try again.",
  "TERMINAL_IS_OFFLINE": "Connection failed - Terminal is offline!",
  "INPUT_FIELD_IS_EMPTY": "Input field is empty",
  "TERMINAL_ID": "Terminal ID",
  "TERMINAL_PASSWORD": "Terminal Password",
  "CONNECT": "Connect",
  // in app.service
  "WRONG_DATA_AT_STORAGE": "wrong data at local storage",
  "CONNECTION_FAILED": "Connection failed",
  // in content.service
  "LOGGED_IN_SUCCESSFULLY": "logged in",
  "LOGGED_OUT_SUCCESSFULLY": "logged out",
  "CHECK_IS_NOT_ALLOWED": "The required authorization is missing at Projectfacts - Check in/out is not allowed",
  "CHECK_CAN_NOT_SAVED": "Can not save Check in/out at Projectfacts",
  "UNKNOWN_USER_RFID": "Unknown user RFID",
  // in workerList.dialog
  "LOGGEDIN_WORKERS": "Workers",
  "ABSENT_WORKERS": "Absent workers",
  "CHECK_IN": "Check-in",
  "CHECK_OUT": "Check-out"
};
